const MR = {
  ibanLength: 27,
};
export { MR };
